import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { environment } from '../../../environments/environment';
import { Observable } from "rxjs";
import { TextDataResponse } from 'src/app/common/model/TextDataResponse';

@Injectable({
  providedIn: 'root'
})

@Injectable()
export class EquipmentService {
  getAllSitesUrl = environment.apiBaseUrl + "Facility/productionfacilities";
  getEquipmentsUrl = environment.apiBaseUrl + "EquipmentAndTechnology/getequipments";
  getEquipmentInfoUrl = environment.apiBaseUrl + "EquipmentAndTechnology/getequipment";
  getEquipmentTypesUrl = environment.apiBaseUrl + "MasterData/getequipmenttypes";
  getEquipmentProvidersUrl = environment.apiBaseUrl + "MasterData/getequipmentproviders";
  getTechProvidersUrl = environment.apiBaseUrl + "MasterData/gettechnologyproviders";
  getEngineeringProvidersUrl = environment.apiBaseUrl + "MasterData/getengineeringproviders";
  getIndustrialGasProvidersUrl = environment.apiBaseUrl + "MasterData/getindustrialgasproviders";
  getBusinessModelsUrl = environment.apiBaseUrl + "MasterData/getbusinessmodels";
  getProspectListItemsUrl = environment.apiBaseUrl + "MasterData/getprospectlistitems";
  saveEquipmentDetailsUrl = environment.apiBaseUrl + "EquipmentAndTechnology/updateequipmentinfo";
  saveEquipmentProvidersUrl = environment.apiBaseUrl + "MasterData/updateequipmentprovider";
  saveTechProvidersUrl = environment.apiBaseUrl + "MasterData/updatetechnologyprovider";
  saveEngineeringProvidersUrl = environment.apiBaseUrl + "MasterData/updateengineeringprovider";
  saveIndustrialGasProvidersUrl = environment.apiBaseUrl + "MasterData/updateindustrialgas";
  saveEquipmentTypeUrl = environment.apiBaseUrl + "MasterData/updateequipmenttype";
  constructor(protected http: HttpClient) {
  }

  getSites(): Observable<SitePlant[]> {
    let url = this.getAllSitesUrl;
    return this.http.get<SitePlant[]>(url);
  }

  getEquipments(): Observable<TextDataResponse> {
    let url = this.getEquipmentsUrl;
    return this.http.get<TextDataResponse>(url);
  }

  getEquipmentInfo(id: number): Observable<Equipment> {
    let url = this.getEquipmentInfoUrl;
    return this.http.get<Equipment>(`${url}/${id}`);  
  }

  getEquipmentTypes(): Observable<Provider[]> {
    let url = this.getEquipmentTypesUrl;
    return this.http.get<Provider[]>(url);
  }

  getBusinessModels(): Observable<Provider[]> {
    let url = this.getBusinessModelsUrl;
    return this.http.get<Provider[]>(url);
  }

  getProspectListItems(): Observable<ProspectListItem[]> {
    let url = this.getProspectListItemsUrl;
    return this.http.get<ProspectListItem[]>(url);
  }

  getProviders(providerType: Providers): Observable<Provider[]> {
    let url = '';
    switch (providerType) {
      case Providers.Equipment:
        url = this.getEquipmentProvidersUrl;
          break;
      case Providers.Technology:
          url = this.getTechProvidersUrl;
          break;
      case Providers.Engineering:
          url = this.getEngineeringProvidersUrl;
          break;
      case Providers.IndustrialGas:
          url = this.getIndustrialGasProvidersUrl;
          break;
      default:
          break;
  }
    return this.http.get<Provider[]>(url);
  }

  saveEquipmentDetails(data: Equipment): Observable<boolean> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.http.post<boolean>(this.saveEquipmentDetailsUrl, JSON.stringify(data, null, 2), httpOptions);
  }

  saveProviderInfo(data: Provider, type: Providers): Observable<number> {
    let url = '';
    switch (type) {
      case Providers.Equipment:
        url = this.saveEquipmentProvidersUrl;
          break;
      case Providers.Technology:
          url = this.saveTechProvidersUrl;
          break;
      case Providers.Engineering:
          url = this.saveEngineeringProvidersUrl;
          break;
      case Providers.IndustrialGas:
          url = this.saveIndustrialGasProvidersUrl;
          break;
      case Providers.EquipmentType:
          url = this.saveEquipmentTypeUrl;
          break;
      default:
          break;
  }
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })};
    return this.http.post<number>(url, JSON.stringify(data, null, 2), httpOptions);
  }
}

export class SitePlant {
  siteId: number;
  plantName: string;
}

export class Provider {
  id: number;
  providerName: string;
  activeFlag: boolean;
}

export class Equipment {
  equipmentId: number;
  equipmentDescription: string;
  siteId: number;
  customerSiteId?: number;
  plantShortDesc: string;
  customerSiteDesc: string;  
  productionFacilityId: string;
  equipmentType: string;
  equipmentProvider: string;
  technologyProvider: string;
  engineeringProvider: string;
  industrialGasProvider: string;
  equipmentTypeId?: number;
  equipmentProviderId?: number;
  technologyProviderId?: number;
  engineeringProviderId?: number;
  industrialGasProviderId?: number;
  businessModel: string;
  supplyMode: string;
  supplyModeNotes: string = '';
  awardYear: string;
  awardStatus: string;
  lastContactedBy: string;
  lastContactedDate: Date;
  equipmentCustomerVarious: boolean;
  equipmentCustomerUnspecified: boolean;
  activeFlag: boolean;
}

export class EquipmentType {
  name: string;
  activeFlag: boolean;
}

export class ProspectListItem {
  listItem: string;
  listType: string;
}

export enum Providers {
  Equipment,
  Technology,
  Engineering,
  IndustrialGas,
  EquipmentType
}
